import { render } from "./Order-select.vue?vue&type=template&id=2be70a00"
import script from "./Order-select.vue?vue&type=script&lang=js"
export * from "./Order-select.vue?vue&type=script&lang=js"

import "./Order-select.vue?vue&type=style&index=0&id=2be70a00&lang=css"

import exportComponent from "/Users/thomas/Desktop/CNT/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__